/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".action[_ngcontent-%COMP%]{cursor:pointer;text-decoration:none}i.action[_ngcontent-%COMP%]:hover{background:#c4c5c4}.ui-confirmdialog-message[_ngcontent-%COMP%]{font-size:14px;font-weight:700}"];
export { styles as styles };
